import type { RouteRecordRaw } from 'vue-router'

import { registerSummaryMessages } from './i18n'

import { registerAnomalyMessages } from '@/features/anomalies'
import { registerInsightMessages } from '@/features/insights'
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, i18n, type SupportedLocale } from '@/shared/i18n'

function activeLocale(): SupportedLocale {
  const locale = i18n.global.locale.value
  return (SUPPORTED_LOCALES as readonly string[]).includes(locale)
    ? (locale as SupportedLocale)
    : DEFAULT_LOCALE
}

export const SUMMARY_ROUTE = { name: 'Summary' } as const
export const WEEKLY_SUMMARY_ROUTE = { name: 'WeeklySummaryLatest' } as const

async function loadSummaryMessages(): Promise<void> {
  await registerSummaryMessages(activeLocale())
}

export const summaryRoutes: RouteRecordRaw[] = [
  {
    path: 'summary',
    name: SUMMARY_ROUTE.name,
    component: () => import('./components/SummaryPage.vue'),
    meta: {
      navKey: 'summary',
      titleKey: 'shell.summary.title',
    },
    beforeEnter: async () => {
      const locale = activeLocale()
      await Promise.all([
        registerSummaryMessages(locale),
        registerAnomalyMessages(locale),
        registerInsightMessages(locale),
      ])
    },
  },
  {
    path: 'notifications/summary/weekly/:legacyPath(.*)*',
    name: WEEKLY_SUMMARY_ROUTE.name,
    component: () => import('./components/WeeklySummaryPage.vue'),
    meta: {
      titleKey: 'summary.weeklyReport.title',
      contentInset: 'none',
    },
    beforeEnter: loadSummaryMessages,
  },
]
